import React from 'react'
import styles from './Tooltips.scss'
import {CTA} from 'common/styleguide/CTA'
import {WithTooltip} from 'common/styleguide/WithTooltip'

// only top is supported for now
// const POSITIONS = ['top', 'right', 'bottom', 'left']

export class Tooltips extends React.PureComponent {
  render () {
    return (
      <div className={styles.Tooltips}>
        <h1>Tooltips</h1>
        <p>
          We have tooltips!
        </p>
        {/* Because we use tippy.js event delegation to dynamically create
            tippy instances when a tooltip is first hovered, a shown-by-default
            tooltip can't be created just by using data attributes. WithTooltip
            is an escape hatch that allows more precise overrides over the
            standard tooltip behavior */}
        <WithTooltip trigger='manual' show interactive delay={[0, 0]} hideOnClick={false}>
          <CTA title="I'm a tooltip!" inline>Manual Tooltip</CTA>
        </WithTooltip>
        <CTA inline data-tip title="I'm a tooltip!">Hover Tooltip</CTA>
        <p>
          All of the <a href='https://atomiks.github.io/tippyjs/' target='_blank'>tippy.js</a> options are supported:
        </p>
        <div>
          <CTA data-tip title='To the left!' data-tippy-placement='left' inline>Left Tooltip</CTA>
          <CTA data-tip title='Underneath!' data-tippy-placement='bottom' inline>Bottom Tooltip</CTA>
          <CTA data-tip title='To the right!' data-tippy-placement='right' inline>Right Tooltip</CTA>
        </div>
        <div>
          {/* note: there's a tippy.js bug with delegated tooltips that causes them to appear when first hovered, even if they have a non-hover trigger */}
          <CTA data-tip title='Clicked!' data-tippy-trigger='click' data-tippy-delay='[0, 0]' inline>Click Tooltip</CTA>
        </div>
      </div>
    )
  }
}
